import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useI18n } from "../lib/i18n";
import { Icon } from "./Icons";

function isStandalone() {
  return window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

export default function InstallAppButton() {
  const { t } = useI18n();
  const [installPrompt, setInstallPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandalone);
  const [guideOpen, setGuideOpen] = useState(false);

  useEffect(() => {
    const displayMode = window.matchMedia("(display-mode: standalone)");
    const capturePrompt = (event) => {
      event.preventDefault();
      setInstallPrompt(event);
    };
    const markInstalled = () => {
      setInstalled(true);
      setInstallPrompt(null);
      setGuideOpen(false);
    };
    const syncDisplayMode = () => setInstalled(isStandalone());

    window.addEventListener("beforeinstallprompt", capturePrompt);
    window.addEventListener("appinstalled", markInstalled);
    displayMode.addEventListener?.("change", syncDisplayMode);
    return () => {
      window.removeEventListener("beforeinstallprompt", capturePrompt);
      window.removeEventListener("appinstalled", markInstalled);
      displayMode.removeEventListener?.("change", syncDisplayMode);
    };
  }, []);

  const install = async () => {
    if (!installPrompt) {
      setGuideOpen(true);
      return;
    }
    await installPrompt.prompt();
    const choice = await installPrompt.userChoice;
    setInstallPrompt(null);
    if (choice.outcome === "accepted") setInstalled(true);
  };

  if (installed) return null;

  return (
    <>
      <button className="install-app-button" type="button" onClick={install} aria-label={t("Instalo aplikacionin")}>
        <Icon name="download" size={17} />
        <span>{t("Instalo aplikacionin")}</span>
      </button>
      {guideOpen ? createPortal((
        <div className="install-guide" role="dialog" aria-modal="true" aria-labelledby="install-guide-title" onMouseDown={(event) => {
          if (event.target === event.currentTarget) setGuideOpen(false);
        }}>
          <section className="install-guide__card">
            <header>
              <span className="icon-badge"><Icon name="download" size={25} /></span>
              <div>
                <span>{t("Përdore si aplikacion")}</span>
                <h2 id="install-guide-title">{t("Instalo Juris Prudent")}</h2>
              </div>
              <button className="icon-action" type="button" onClick={() => setGuideOpen(false)} aria-label={t("Mbyll")}><Icon name="close" size={19} /></button>
            </header>
            <p>{t("Krijoni një ikonë në desktop ose ekranin kryesor dhe hapeni Juris Prudent në një dritare aplikacioni pa shiritin e zakonshëm të shfletuesit.")}</p>
            <div className="install-guide__steps">
              <article><Icon name="building" size={22} /><div><strong>{t("Në kompjuter")}</strong><span>{t("Në Chrome ose Edge, përdorni ikonën e instalimit në shiritin e adresës ose menynë ⋮ → Instalo Juris Prudent.")}</span></div></article>
              <article><Icon name="phone" size={22} /><div><strong>Android</strong><span>{t("Në Chrome, hapni menynë ⋮ dhe zgjidhni Instalo aplikacionin ose Shto në ekranin kryesor.")}</span></div></article>
              <article><Icon name="phone" size={22} /><div><strong>iPhone / iPad</strong><span>{t("Në Safari, prekni Share dhe pastaj Add to Home Screen / Shto në ekranin kryesor.")}</span></div></article>
            </div>
            <button className="button button--gold button--wide" type="button" onClick={() => setGuideOpen(false)}>{t("U kuptua")}</button>
          </section>
        </div>
      ), document.body) : null}
    </>
  );
}
